import { render, staticRenderFns } from "./SocialLearningComments.vue?vue&type=template&id=70ecf559&scoped=true&"
import script from "./SocialLearningComments.vue?vue&type=script&lang=js&"
export * from "./SocialLearningComments.vue?vue&type=script&lang=js&"
import style0 from "./SocialLearningComments.vue?vue&type=style&index=0&id=70ecf559&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ecf559",
  null
  
)

export default component.exports